import React from "react"

export const DocScrollIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M1.5 6C1.5 4.4 2.9 3 4.5 3V3C6.15685 3 7.5 4.34315 7.5 6V8H1.5V6Z" />
      <path d="M4.5 3H16.5C18.1 3 19.5 4.4 19.5 6V17" />
      <path d="M10.5 21C8.8 21 7.5 19.6 7.5 18V6C7.5 4.4 6.1 3 4.5 3" />
      <path d="M10.5 21H19.5C21.1 21 22.5 19.6 22.5 18V17H13.5V18C13.5 19.6 12.1 21 10.5 21Z" />
      <path d="M10.5 11.8281C10.5 11.8281 11.625 13.3281 13.5 13.3281C15.375 13.3281 16.5 11.8281 16.5 11.8281" />
      <path d="M11.5 7.82812H11.51" />
      <path d="M15.5 7.82812H15.51" />
    </g>
    <path d="M15.7012 8.59961C16.2535 8.59961 16.7012 8.15189 16.7012 7.59961C16.7012 7.04732 16.2535 6.59961 15.7012 6.59961C15.1489 6.59961 14.7012 7.04732 14.7012 7.59961C14.7012 8.15189 15.1489 8.59961 15.7012 8.59961Z" fill="currentColor"/>
    <path d="M11.5 8.59961C12.0523 8.59961 12.5 8.15189 12.5 7.59961C12.5 7.04732 12.0523 6.59961 11.5 6.59961C10.9477 6.59961 10.5 7.04732 10.5 7.59961C10.5 8.15189 10.9477 8.59961 11.5 8.59961Z" fill="currentColor"/>
  </svg>
)
